import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitUtils} from '@hit/components/src/utils/hit/HitUtils';
import {required} from '@vuelidate/validators';
import {cloneDeep} from 'lodash';

export default class AddressBankAccount extends BaseModel {
  constructor({
    id,
    designation,
    accountNo = undefined,
    branchCode = undefined,
    beneficiaryName = undefined,
    account_no = undefined,
    branch_code = undefined,
    beneficiary_name = undefined,
  }) {
    const accountNumber = accountNo ?? account_no;
    super(id, accountNumber, designation);
    this.accountNo = accountNumber;
    this.branchCode = branchCode ?? branch_code;
    this.beneficiaryName = beneficiaryName ?? beneficiary_name;
  }

  get fullDesignation() {
    return HitUtils.createStandardDesignation(this, 'accountNo');
  }

  static get config() {
    const config = BaseModel.config;
    config.addable = false;
    return config;
  }
  get config() {
    return AddressBankAccount.config;
  }

  static get fkName() {
    return 'address_id';
  }
  static get apiRoute() {
    return 'address_bank_account';
  }
  static get detailPageRoute() {
    return 'addressDetail';
  }
  static get listPageRoute() {
    return 'addressDetail';
  }
  get fkName() {
    return AddressBankAccount.fkName;
  }
  get apiRoute() {
    return AddressBankAccount.apiRoute;
  }
  get listPageRoute() {
    return AddressBankAccount.listPageRoute;
  }
  get detailPageRoute() {
    return AddressBankAccount.detailPageRoute;
  }

  static get attrsToStoreInForm() {
    return ['designation', 'accountNo', 'beneficiaryName', 'branchCode'];
  }

  static get joinFilterColumns() {
    return ['account_no', 'designation'];
  }

  static get joinAttrsKey() {
    return ['designation', 'accountNo', 'beneficiaryName', 'branchCode'];
  }

  static get joinAttrsForDesignation() {
    return this.getAttributes(['designation', 'accountNo']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'designation',
      'accountNo',
      'beneficiaryName',
      'branchCode',
    ]);
  }

  static get entityListDisplayAttrs() {
    return this.browserDisplayAttrs;
  }

  static get listDisplayAttrs() {
    return this.browserDisplayAttrs;
  }

  static get orderKey() {
    return 'sort_order';
  }
  static get orderOrder() {
    return 'asc';
  }

  static get dataListConfig() {
    return {
      zone1Field: 'designation',
      zone2CustomFunction: (account) => `${account?.beneficiaryName ?? ''}`,
      zone3CustomFunction: (account) => {
        if (account?.branchCode) {
          return `${account?.accountNo} / ${account?.branchCode}`;
        }
        return account?.accountNo;
      },
    };
  }

  static get detailAttrs() {
    return this.getAddressDetailAttrs(true);
  }

  /**
   * Attributes for the bank account panel on address detail.
   * @param {boolean} branchCodeRequired when false (BIC label locale), branch code is optional
   */
  static getAddressDetailAttrs(branchCodeRequired = true) {
    const attrs = cloneDeep(
      this.getAttributes(
        ['designation', 'beneficiaryName', 'accountNo', 'branchCode'],
        ['sortOrder'],
      ),
    );
    const branchCodeAttr = attrs.find((attr) => attr?.name === 'branchCode');
    if (branchCodeAttr && branchCodeRequired) {
      branchCodeAttr.validations = {required};
    }
    return attrs.filter(Boolean);
  }

  static get allAttributes() {
    return [
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '1fr'}),
      new AT.StringAttribute({
        name: 'beneficiaryName',
        column: 'beneficiary_name',
        validations: {required},
        tableProperties: {
          header: 'hit-app.common.beneficiary-name',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'accountNo',
        column: 'account_no',
        validations: {required},
        tableProperties: {
          header: 'hit-app.common.account-no',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'branchCode',
        column: 'branch_code',
        tableProperties: {
          header: 'hit-app.common.branch-code',
          maxWidth: '1fr',
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
    ];
  }
}
